/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { ComplexObject, DataType, Entity } from 'breeze-client';
import _ from 'lodash-es';
import { ComplexValues, EntityValues } from '../services';

export const isEntity = (obj: Entity): obj is Entity => !!obj?.entityAspect;
export const isComplexObject = (obj: ComplexObject): obj is ComplexObject =>
  !!obj?.complexAspect;

export function extractData<T extends Entity>(
  entity: T,
  includeKeys?: boolean,
  sparse?: boolean
): EntityValues<T>;
export function extractData<T extends ComplexObject>(
  complexObject: T,
  includeKeys?: boolean,
  sparse?: boolean
): ComplexValues<T>;
export function extractData<T extends Entity | ComplexObject>(
  entityOrComplextObject: T,
  includeKeys?: boolean,
  sparse?: boolean
): any {
  const structuralType =
    (entityOrComplextObject as Entity).entityType ||
    (entityOrComplextObject as ComplexObject).complexType;
  if (!structuralType) {
    return {};
  }

  const props = structuralType.dataProperties.filter(
    (x) => (!x.isPartOfKey || (x.isPartOfKey && includeKeys)) && !x.isUnmapped
  );
  const data = {} as T;
  props.forEach((prop) => {
    if (prop.isComplexProperty) {
      data[prop.name] = extractData(
        entityOrComplextObject[prop.name] as ComplexObject,
        includeKeys,
        sparse
      );
    } else {
      data[prop.name] = entityOrComplextObject[prop.name];
    }
  });

  if (sparse) {
    return _.pickBy(
      data,
      (value) =>
        value !== undefined &&
        value !== null &&
        value !== DataType.Guid.defaultValue
    );
  }

  return data;
}
